import env from "Consts/env";
import { apiSlice } from "../api/apiSlice";

export const homeApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getSectionHome: builder.query({
			query: (args) => {

				const { isDirect } = args.params;

				const isDirectBoolean = !!isDirect;

				const baseURL = isDirectBoolean
					? `${process.env.NEXT_PUBLIC_MAGENTO_BS}/magento/homepage`
					: "/api/homepage";

				return {
					url: baseURL,
					headers: {
						...env.HEADERS,
					},
					validateStatus: (response) => response.status === 304
						|| (response.status >= 200 && response.status < 300)
					,
				};

			},
			providesTags: ["Home"],
		}),
		getHomeDetail: builder.query({
			query: (args) => {

				const { isDirect } = args.params;

				const isDirectBoolean = !!isDirect;

				const baseURL = isDirectBoolean
					? `${process.env.NEXT_PUBLIC_MAGENTO_BASE}${args.params.endpoint}`
					: `/api/${args.params.endpoint}`;

				return {
					url: baseURL,
					headers: {
						...env.HEADERS,
					},
					params: {
						...args.params,
					},
					transformResponse: (response) => ({
						status: response?.status ?? response.meta.code, data: response,
					}),
					validateStatus: (response) => response.status === 304
						|| (response.status >= 200 && response.status < 300)
					,
				};

			},
		}),
	}),
});

export const {
	useGetSectionHomeQuery,
	useGetHomeDetailQuery,
	useLazyGetHomeDetailQuery,
} = homeApiSlice;
